var blockquote_default = {
  "fontElementMap": "-XiNm",
  "quoteContainer": "pJkyn",
  "quote": "eFTjz"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
